/**
 * Generated runtime TestId mirror for frontend/src/features/certification/components/WizardStepReviewSettings.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const WizardStepReviewSettingsTestIds = {
  checkboxAutoRevokeOnOverdue: "checkbox-auto-revoke-on-overdue",
  checkboxOverrideReviewFrequency: "checkbox-override-review-frequency",
  comboboxCampaignOwner: "combobox-campaign-owner",
  inputGracePeriodDays: "input-grace-period-days",
  inputReviewFrequencyDays: "input-review-frequency-days",
  optionNonResponseAutoRevoke: "option-non-response-auto-revoke",
  optionNonResponseEscalate: "option-non-response-escalate",
  optionNonResponseNoChange: "option-non-response-no-change",
  optionReviewerManager: "option-reviewer-manager",
  optionReviewerProfileOwner: "option-reviewer-profile-owner",
  optionReviewerResourceOwner: "option-reviewer-resource-owner",
  selectNonResponseAction: "select-non-response-action",
  selectReviewerType: "select-reviewer-type"
} as const;
